<template>
    <div id="car-insurable-extras">
        <v-layout slot="block-elements" row wrap class="pl-4">
            <v-alert
                :color="ovbColors ? colors.OVBHimbeer : undefined"
                type="warning" v-if="!verificationMode"
            >
                Az itt felsorolt extrákat abban az esetben is jelölni kell, ha az EUROTAX
                adatbázis szerint a választott gépjármű modell ezt szériafelszereltségként
                tartalmazza. Egyes biztosítók esetén csak akkor lesz fedezetbe vonva az
                extra felszereltség, ha itt ezeket jelöli.
            </v-alert>
            <template v-if="eurotaxVehicleType === EUROTAX_TYPE_CAR">
                <BnFormField :attributes="extrak_.klima"/>
                <BnFormField :attributes="extrak_.osszkerekhajtas"/>
                <BnFormField :attributes="extrak_.kulonleges_kerek"/>
                <BnFormField :attributes="extrak_.automatasebvalto"/>
                <BnFormField :attributes="extrak_.led_fenyszorok"/>
                <BnFormField :attributes="extrak_.xenon_fenyszorok"/>
                <BnFormField :attributes="extrak_.navigacio"/>
                <BnFormField :attributes="extrak_.borkarpit"/>
                <BnFormField :attributes="extrak_.extra_fenyezes"/>
                <BnFormField :attributes="extrak_.ultrahangos_parkolasiranyitas"/>
                <BnFormField :attributes="extrak_.hifi"/>
                <BnFormField :attributes="extrak_.video"/>
                <BnFormField :attributes="extrak_.vezetestamogatas"/>
                <BnFormField :attributes="extrak_.fixuvegteto"/>
                <BnFormField :attributes="extrak_.nyithatouvegteto"/>
                <BnFormField :attributes="extrak_.mozgathato_tetoboritas"/>
                <BnFormField :attributes="extrak_.adaptiv"/>
                <BnFormField :attributes="extrak_.gallytoro"/>
                <BnFormField :attributes="extrak_.vonohorog"/>
                <BnFormField :attributes="extrak_.tolatoszenzor"/>
                <BnFormField :attributes="extrak_.karosszeria_diszlec"/>
                <BnFormField :attributes="extrak_.karosszeria_felirat"/>
                <BnFormField :attributes="extrak_.karosszeria_matrica"/>
                <BnFormField :attributes="extrak_.karosszeria_uvegfolia"/>
            </template>
            <template v-else-if="eurotaxVehicleType === EUROTAX_TYPE_MOTOR">
                <BnFormField :attributes="extrak_.xenon_led_fenyszoro"/>
                <BnFormField :attributes="extrak_.gyari_navigacio"/>
                <BnFormField :attributes="extrak_.fixen_rogzitett_tarolodoboz"/>
                <BnFormField :attributes="extrak_.oldalkocsi_utanfuto"/>
                <BnFormField :attributes="extrak_.utolag_felszerelt_aramvonalidomok"/>
                <BnFormField :attributes="extrak_.utolag_felszerelt_kipufogo"/>
                <BnFormField :attributes="extrak_.bukosisak"/>
                <BnFormField :attributes="extrak_.motoros_ruha"/>
            </template>
        </v-layout>
    </div>

</template>

<script>

import { OVB_Himbeer as OVBHimbeer } from '../../modules/Color';
import { EUROTAX_TYPE_CAR, EUROTAX_TYPE_MOTOR } from './utilities';

export default {
    name: 'CarInsurableExtras',

    props: {
        editable: {
            required: false,
            default: true,
        },
        verificationMode: {
            required: false,
            default: false,
        },
        ovbColors: {
            type: Boolean,
            default: false,
        },
        eurotaxVehicleType: {
            type: Number,
            default: EUROTAX_TYPE_CAR,
        },
    },

    data() {
        return {
            EUROTAX_TYPE_CAR,
            EUROTAX_TYPE_MOTOR,
            colors: {
                OVBHimbeer,
            },
            extrak_: {
                klima: {
                    label: 'Légkondícionáló',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.klima',
                    mezo: 'gepjarmu.extrak.klima',
                    help: false,
                },
                osszkerekhajtas: {
                    label: 'Összkerékhajtás',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.osszkerekhajtas',
                    mezo: 'gepjarmu.extrak.osszkerekhajtas',
                    help: false,
                },
                kulonleges_kerek: {
                    label: 'Különleges keréktárcsa',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.kulonleges_kerek',
                    mezo: 'gepjarmu.extrak.kulonleges_kerek',
                    help: false,
                },
                automatasebvalto: {
                    label: 'Automata sebességváltó',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.automatasebvalto',
                    mezo: 'gepjarmu.extrak.automatasebvalto',
                    help: false,
                },
                led_fenyszorok: {
                    label: 'LED, adaptív LED, lézer fényszóró',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.led_fenyszorok',
                    mezo: 'gepjarmu.extrak.led_fenyszorok',
                    help: false,
                },
                xenon_fenyszorok: {
                    label: 'Xenon, Bi-Xenon fényszóró',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.xenon_fenyszorok',
                    mezo: 'gepjarmu.extrak.xenon_fenyszorok',
                    help: false,
                },
                navigacio: {
                    label: 'Beépített navigáció',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.navigacio',
                    mezo: 'gepjarmu.extrak.navigacio',
                    help: false,
                },
                /* legzsak: {
                        label: '',
                        type: 'checkbox',
                        visible: true,
                        editable: this.editable,
                        rules: [],
                        path: 'gepjarmu.extrak.legzsak',
                        mezo: 'gepjarmu.extrak.legzsak',
                        help: false
                    },
                    legzsak_db: {
                        label: '',
                        type: 'checkbox',
                        visible: true,
                        editable: this.editable,
                        rules: [],
                        path: 'gepjarmu.extrak',
                        mezo: 'gepjarmu.extrak',
                        help: false
                    }, */
                borkarpit: {
                    label: 'Bőr vagy részben bőr belső gyári kárpitozás',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.borkarpit',
                    mezo: 'gepjarmu.extrak.borkarpit',
                    help: false,
                },
                /* emabisz: {
                        modozatok: [CASCO, MIND],
                        vehicleTypes: [SZGK, TEHER],
                        scenarios: [AJANLATI_ADATOK, TORZS],
                        label: '',
                        type: 'checkbox',
                        visible: true,
                        editable: this.editable,
                        rules: [],
                        path: 'gepjarmu.extrak.emabisz',
                        mezo: 'gepjarmu.extrak.emabisz',
                        help: false
                    }, */
                extra_fenyezes: {
                    label: 'Extra fényezés',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.extra_fenyezes',
                    mezo: 'gepjarmu.extrak.extra_fenyezes',
                    help: false,
                },
                ultrahangos_parkolasiranyitas: {
                    label: 'Ultrahangos parkolásirányítás',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.ultrahangos_parkolasiranyitas',
                    mezo: 'gepjarmu.extrak.ultrahangos_parkolasiranyitas',
                    help: false,
                },
                hifi: {
                    label: 'Audió rendszer',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.hifi',
                    mezo: 'gepjarmu.extrak.hifi',
                    help: false,
                },
                video: {
                    label: 'Beépített videó',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.video',
                    mezo: 'gepjarmu.extrak.video',
                    help: false,
                },
                vezetestamogatas: {
                    label: 'Aktív menetbiztonsági berendezés vagy vészfék asszisztens',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.vezetestamogatas',
                    mezo: 'gepjarmu.extrak.vezetestamogatas',
                    help: false,
                },
                fixuvegteto: {
                    label: 'Fix üvegtető',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.fixuvegteto',
                    mezo: 'gepjarmu.extrak.fixuvegteto',
                    help: false,
                },
                nyithatouvegteto: {
                    label: 'Nyitható üvegtető',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.nyithatouvegteto',
                    mezo: 'gepjarmu.extrak.nyithatouvegteto',
                    help: false,
                },
                /*
                tetoablak: {
                    label: 'Tetőablak',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.tetoablak',
                    mezo: 'gepjarmu.extrak.tetoablak',
                    help: false,
                },
                */
                mozgathato_tetoboritas: {
                    label: 'Mozgatható tetőborítás',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.mozgathato_tetoboritas',
                    mezo: 'gepjarmu.extrak.mozgathato_tetoboritas',
                    help: false,
                },
                adaptiv: {
                    label: 'Adaptív lengéscsillapítás',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.adaptiv',
                    mezo: 'gepjarmu.extrak.adaptiv',
                    help: false,
                },
                gallytoro: {
                    label: 'Gallytörő rács',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.gallytoro',
                    mezo: 'gepjarmu.extrak.gallytoro',
                    help: false,
                },
                vonohorog: {
                    label: 'Vonóhorog',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.vonohorog',
                    mezo: 'gepjarmu.extrak.vonohorog',
                    help: false,
                },
                tolatoszenzor: {
                    label: 'Tolatószenzor / kamera',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.tolatoszenzor',
                    mezo: 'gepjarmu.extrak.tolatoszenzor',
                    help: false,
                },
                karosszeria_diszlec: {
                    label: 'Díszlécek',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.karosszeria_diszlec',
                    mezo: 'gepjarmu.extrak.karosszeria_diszlec',
                    help: false,
                },
                karosszeria_felirat: {
                    label: 'Karosszéria feliratok',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.karosszeria_felirat',
                    mezo: 'gepjarmu.extrak.karosszeria_felirat',
                    help: false,
                },
                karosszeria_matrica: {
                    label: 'Karosszéria matricák',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.karosszeria_matrica',
                    mezo: 'gepjarmu.extrak.karosszeria_matrica',
                    help: false,
                },
                karosszeria_uvegfolia: {
                    label: 'Üvegfóliázás',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.karosszeria_uvegfolia',
                    mezo: 'gepjarmu.extrak.karosszeria_uvegfolia',
                    help: false,
                },
                xenon_led_fenyszoro: {
                    label: 'Xenon/LED fényszóró',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.xenon_led_fenyszoro',
                    mezo: 'gepjarmu.extrak.xenon_led_fenyszoro',
                    help: false,
                },
                gyari_navigacio: {
                    label: 'Gyári navigáció',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.gyari_navigacio',
                    mezo: 'gepjarmu.extrak.gyari_navigacio',
                    help: false,
                },
                fixen_rogzitett_tarolodoboz: {
                    label: 'Fixen rögzített tárolódoboz',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.fixen_rogzitett_tarolodoboz',
                    mezo: 'gepjarmu.extrak.fixen_rogzitett_tarolodoboz',
                    help: false,
                },
                oldalkocsi_utanfuto: {
                    label: 'Oldalkocsi vagy utánfutó',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.oldalkocsi_utanfuto',
                    mezo: 'gepjarmu.extrak.oldalkocsi_utanfuto',
                    help: false,
                },
                utolag_felszerelt_aramvonalidomok: {
                    label: 'Utólag felszerelt áramvonalidomok',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.utolag_felszerelt_aramvonalidomok',
                    mezo: 'gepjarmu.extrak.utolag_felszerelt_aramvonalidomok',
                    help: false,
                },
                utolag_felszerelt_kipufogo: {
                    label: 'Utólag felszerelt kipufogó',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.utolag_felszerelt_kipufogo',
                    mezo: 'gepjarmu.extrak.utolag_felszerelt_kipufogo',
                    help: false,
                },
                bukosisak: {
                    label: 'Bukósisak',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.bukosisak',
                    mezo: 'gepjarmu.extrak.bukosisak',
                    help: false,
                },
                motoros_ruha: {
                    label: 'Motoros ruha',
                    type: 'checkbox',
                    visible: true,
                    editable: this.editable,
                    rules: [],
                    path: 'gepjarmu.extrak.motoros_ruha',
                    mezo: 'gepjarmu.extrak.motoros_ruha',
                    help: false,
                },
            },
        };
    },
};
</script>

<style>

#car-insurable-extras .v-input .v-input--selection-controls .v-input--checkbox {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

#car-insurable-extras.v-input--selection-controls {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

#car-insurable-extras div.v-messages.theme--light {
    min-height: 0;
    height: 0;
}

#car-insurable-extras div.flex.v-label.v-label--active.theme--light.md12.xs12.offset-md1.offset-xs1 {
    min-height: 0;
    height: 0;
}

#car-insurable-extras div.v-input.v-input--selection-controls.v-input--checkbox.theme--light {
    margin-top: 0;
}

#car-insurable-extras .v-input--selection-controls .v-input__slot, .v-input__slot {
    margin-bottom: 12px !important;
}

</style>
